<template>
    <div ref="sectionRef" class="product-footer">
        <MaltImg src="/cms-front/ai-header.svg?vh=b817ac" width="600" class="product-footer__svg" alt="AI Search Footer" />
    </div>
</template>

<script lang="ts" setup>
    import {MaltImg} from '#components';
</script>

<style lang="scss">
    @use '@malt/joy-entrypoint/src/sass/base/2_mixins/media-queries/media-queries' as mq;

    .product-footer {
        pointer-events: none;
        position: relative;
        height: 30vw;
        z-index: -1;

        @include mq.screen_md(min) {
            height: 10vw;
        }

        img {
            display: block;
            position: absolute;
            bottom: 0;
            width: 100%;
            transform: scaleY(-1);
        }
    }
</style>
